// extracted by mini-css-extract-plugin
export var modal = "_dd-0";